export class Messages {
  static readonly saveRecord = 'Record saved successfully.';
  static readonly deleteConfirmation = 'Are you sure you want to delete selected record?';
  static readonly imgageDeleteConfirmation = 'Are you sure you want to delete selected image?';
  static readonly deleteRecord = 'Record deleted successfully.';
  static readonly ActivatedRecord = 'Record activated successfully.';
  static readonly deleteImage = 'Image deleted successfully.';
  static readonly selectRecord = 'Please select Record.';
  static readonly cancelChanges = 'Are you sure you want to cancel changes?';
  static readonly deleteReference = 'You can not delete this record as reference already exists for this record.';
  static readonly searchCriteria = 'Please enter atleast one search criteria.';
  static readonly alreadyExist = 'Record already exists.';
  static readonly noRecordExist = 'No record exists.';
  static readonly exportInfo = 'No records to export.';
  static readonly requiredWarning = 'Please fill all required fields/proper value(s).';
  static readonly emptyWarning = 'Please fill any detail.';
  static readonly pageChange = 'You have unsaved changes. Are you sure you want to leave this page?';
  static readonly uploadImage = 'Image uploaded successfully.';
  static readonly reconnecting = 'reconnecting...';
  static readonly connected = 'connected to server';
  
}
